module.exports = __webpack_public_path__ + "static/media/greateVictory-0.cffdb08f.png";